export const currencyFormat = new Intl.NumberFormat(window.__litium.constants.currentLocale, { style: "currency", currency: window.__litium.constants.currentCurrency });
export const numberFormat = new Intl.NumberFormat(window.__litium.constants.currentLocale, { style: "decimal", maximumFractionDigits: 2 });
export const numberFormatWithoutDecimal = new Intl.NumberFormat("en-IN", { style: "decimal", maximumFractionDigits: 0 });
export const onHandNumberFormatWithoutDecimal = new Intl.NumberFormat(window.__litium.constants.currentLocale, { style: "decimal", maximumFractionDigits: 0 });
export const dateFormat = new Intl.DateTimeFormat(window.__litium.constants.currentLocale, {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});
